var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRemoveMembers = function SvgRemoveMembers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5c0 2.2-1.8 4-4 4S6 7.2 6 5s1.8-4 4-4 4 1.8 4 4zM10 16.5c0 1 .5 2 1.3 2.5H3.5C1.9 19 1 18.5 1 17c0-4 4.5-7 9-7 3 0 6.1 1.4 7.7 3.5H13c-1.7 0-3 1.3-3 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.5h6c.6 0 1 .4 1 1s-.4 1-1 1h-6c-.6 0-1-.4-1-1s.4-1 1-1z"
  })));
};
export default SvgRemoveMembers;